import { FormFieldConfigType, INPUT_TYPES } from "../../../../types";
import { preProcessFormFields } from "../../../../tools";
import { FILE_ATTACHMENTS_CONSTANTS } from "../../../constants";
import { CARGO_ACCEPTED_FILE_TYPES } from "../../../../FileUpload/constants";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: FILE_ATTACHMENTS_CONSTANTS.FORM_NAME,
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: FILE_ATTACHMENTS_CONSTANTS.FORM_HEADER,
    description: FILE_ATTACHMENTS_CONSTANTS.FORM_DESCRIPTION,
    fields: [
      {
        name: FILE_ATTACHMENTS_CONSTANTS.COMMERCIAL_INVOICE,
        label: FILE_ATTACHMENTS_CONSTANTS.COMMERCIAL_INVOICE_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.COMMERCIAL_INVOICE_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_FRONT,
        label: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_FRONT_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_FRONT_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_REVERSE,
        label: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_REVERSE_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.BILL_OF_LADING_REVERSE_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.PACKING_SLIP,
        label: FILE_ATTACHMENTS_CONSTANTS.PACKING_SLIP_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.PACKING_SLIP_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_PACKAGING_PHOTOS,
        label: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_PACKAGING_PHOTOS_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_PACKAGING_PHOTOS_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_CONTENTS_PHOTOS,
        label: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_CONTENTS_PHOTOS_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.DAMAGED_CONTENTS_PHOTOS_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.PROOF_OF_DELIVERY,
        label: FILE_ATTACHMENTS_CONSTANTS.PROOF_OF_DELIVERY_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.PROOF_OF_DELIVERY_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },

      {
        name: FILE_ATTACHMENTS_CONSTANTS.PROOF_FROM_CARRIER,
        label: FILE_ATTACHMENTS_CONSTANTS.PROOF_FROM_CARRIER_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.PROOF_FROM_CARRIER_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.POLICE_REPORT,
        label: FILE_ATTACHMENTS_CONSTANTS.POLICE_REPORT_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.POLICE_REPORT_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
      {
        name: FILE_ATTACHMENTS_CONSTANTS.ADDITIONAL_DOCUMENTS,
        label: FILE_ATTACHMENTS_CONSTANTS.ADDITIONAL_DOCUMENTS_LABEL,
        description: FILE_ATTACHMENTS_CONSTANTS.ADDITIONAL_DOCUMENTS_DESCRIPTION,
        placeholderText: "",
        type: INPUT_TYPES.UPLOAD,
        constraintText: "",
        multiple: true,
        acceptedFileTypes: CARGO_ACCEPTED_FILE_TYPES,
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
